export enum ChatMode {
  History = 'history',
  Results = 'results',
}
